var __Ajax = function (options) {

    var defaults = {
        action: "",
        area: __Ajax.namespace || "/",
        controller: __Ajax.controller || "",
        type: "POST",
        params: "",
        processData: true,
        contentType: 'application/x-www-form-urlencoded; charset=UTF-8',
        dataType: 'json',
        url: null
    };


    var settings = $.extend({}, defaults, options);

    if (!settings.area.startsWith("/")) {
        settings.area = "/" + settings.area;
    }

    if (!settings.area.endsWith("/")) {
        settings.area += "/";
    }

    settings.beforeSend = typeof settings.start === "function" ? settings.start : settings.beforeSend;
    settings.always = typeof settings.end === "function" ? settings.end : settings.always;

    var headers = {};
    headers['RequestVerificationToken'] = $('input[name=__RequestVerificationToken]').val();
    headers['__RequestType'] = 'AjaxRequest';

    settings.url = settings.url || settings.area + settings.controller + "/" + settings.action;
    var event = (settings.controller || "").toLowerCase() + ":" + (settings.action || "").toLowerCase();

    $.ajax({
        beforeSend: function (jqXHR, x) {
            $(document).trigger(event + ":start", [settings.data]);

            if (typeof settings.beforeSend === "function") {
                settings.beforeSend(settings.data);
            }
        },
        cache: false,
        contentType: settings.contentType,
        async: true,
        headers: headers,
        type: settings.type,
        "url": settings.url,
        processData: settings.processData,
        data: settings.data
    }).done(function (response) {
        if (response.length > 0) {
            response = JSON.parse(response);
            if (response.Succeeded) {
                $(document).trigger(event + ":done", [response]);
                if (typeof settings.done === "function") {
                    settings.done(response);
                }
            } else {
                if (!settings.params.includes("nofeedback")) {

                    var content = "<ul>";
                    $(response.Errors).each(function () {
                        content += "<li>" + this + "</li>";
                    });

                    content += "</ul>";

                    $.showDanger({
                        title: "<i class='far fa-sad-tear fa-3x text-danger float-right'></i>",
                        content: content
                    });
                }
                if (typeof settings.fail === "function") {
                    settings.fail(settings.data, response.Errors);
                }
            }

        }


    }).fail(function (xhr, status, error) {
        var content = error;
        if (xhr.status === 401 || xhr.status === 403) {
            content = "Operación no autorizada. Consulte con el administrador"
        }

        if (xhr.status === 404) {
            content = "El recurso solicitado no existe."
        }

        console.log(settings.params);

        if (!settings.params.includes("nofail")) {
            $.showDanger({
                title: "Error!",
                content: content
            });
        }

        if (typeof settings.fail === "function") {
            settings.fail(settings.data, error);
        }
    }).always(function () {
        $(document).trigger(event + ":end", [settings.data]);
        if (typeof settings.always === "function") {
            settings.always(settings.data);
        }
    });
};
